import styled from '@emotion/styled';
import { Grid } from '@kc-console/common-ui';
import { EllipsisText } from '@kc-console/shared-ui';

import { EllipsisIcon, ListToggleIcon } from './ServiceListItemIcons';

export interface ItemContentProps {
  collapsed: boolean;
  hasSubMenu: boolean;
  isOpen: boolean;
  isSelected: boolean;
  menuName: string;
}

export default function ItemContent({
  collapsed,
  menuName,
  isSelected,
  hasSubMenu,
  isOpen,
}: ItemContentProps) {
  if (collapsed) {
    return (
      <IconContainer container justifyContent={'center'} alignItems={'center'}>
        {hasSubMenu ? <ListToggleIcon open={isOpen} /> : <EllipsisIcon />}
      </IconContainer>
    );
  }

  return (
    <>
      <EllipsisText
        variant={isSelected ? 'label/semibold/md' : 'label/medium/md'}
        direction="vertical"
        message={menuName}
      >
        {menuName}
      </EllipsisText>
      {hasSubMenu && <ListToggleIcon open={isOpen} />}
    </>
  );
}

const IconContainer = styled(Grid)`
  min-width: 24px;
`;
